export const CONSTANT = {
  cookie: {
    login: {
      sessionId: "SMSESSION",
      authorizationId: "loggedIn",
      rememberMe: "rememberMe",
      atgSessionId: "atgJSessionId",
      atgSessionConf: "atgSessionConfNumber",
      atgHashKey: "atgHashKey",
      atgUserId: "atgUserId",
      authZ: "authZ",
      authN: "authN",
    },
    dummyLogginToken: {
      authZ:
        "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJSb2dlcnNBdXRoIiwidG9rZW5EdXJhdGlvbiI6IjMwIiwic3ViamVjdCI6IlJvZ2Vyc0F1dGgiLCJpc3MiOiJodHRwczpcL1wvd3d3LnJvZ2Vycy5jb20iLCJleHAiOjE2OTg3NjU3MjksImlhdCI6MTY5ODE2MDkyOSwia2V5IjoiQkFSZWZcL1wvdmZwdk9TYndcL21QblRWaFBCWE9KTTZYODVZWkptY3NKVzlJdVpQOVROVEQ4c1BDQVd5aWRcLzgwWEJuXC9HWEdXc1FYNGlLK0h6T21JQ3pqN0FOalpaMENPTW5IWjd1REdJRFNLZW9FS3k5Y1piN3JWbnpFZ3JuWkorKzg4c2w4QnFtbGQ4d0g2clNUbWpHckpKZVJROVRVeERTK21pWVkrZHJTNk0rQU5SdHdSeTJOdzNhWVl2OVM4U0lVZkhpazZCXC85cW9SeEFDZVNPT1VuMm9mTVdrN0QzU0ExNGFHeXpaajUwWDNVWFR5XC9Nb2RwY2wzTHVaNEVQSjNPKys0MWl1YnNsT1RFNXV4V1ZxVUZ3bUF3M292ZGFGc3RXZEtjNTlDUWlIMExcLzJ5TkNoZ0x6clZWMDY2NXdSVWRBSDRHSitpM2hJR2lwanAyNTBETlE9PSIsImNvbnRlbnQiOiJFYnYxNkEwNWFIbjQ1UzhWc3NMUXp2Smo2bnhaUjlpYmxwSkRMTzNCXC9CUEdBNGNZa2JiNXV5RE9HOStuK3VQd0hPUGNFaGRZNTBaQzhibkdkeXhUejBmZXJOT29yTjlJbUplMWhrSmlcL3I2MGtiVlBQMG90WjFVZ0Nwa05hK0UrSHlIT2VJWklDWDQwcE5WVlBwMFwvN2FETTNlYjJNUUI3RWtBVlFPeHB2QjNzc0hMSXlmYzQwckRKVjJhdTJRRTg2ZUw5aXQ3RllsZFhQS29LZ012bEdySU11OVV0cFBZZmlkZnExTnlLZmd2ME1NbHhDaXVyMzVjY1VFbGp1TGVMOVpuakliZHlvK2hwMXFEK2tLdVZpM0VXR2ZhTG9IVHBvamhMTEg0K0ZlbFFEMTQ1eEZEdHpTK0ZEMlVDMWY5a25KVzVzRGRjSGRUcElObmtua2lZSjA4dGg1ak1CN1NFbVVqSHZcLzQ5MEo4Ymg5MGpPQys2S1cybjQwVkxtampSWDcwQTBraEpMVk5EdWI5TmY4dVlcL1lIMFJPcDBNUnBVRW1vSEpLcXdRTkFGYTVMMVV6QU92S0VWazJcL2NOM1RiIn0.4PSgGZVoaqXbkRyIFZKnsFqrfeVvpoD0Ofg4_xR7DNs",
      authN:
        "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJSb2dlcnNBdXRoIiwidG9rZW5EdXJhdGlvbiI6IjMwIiwic3ViamVjdCI6IlJvZ2Vyc0F1dGgiLCJpc3MiOiJodHRwczpcL1wvd3d3LnJvZ2Vycy5jb20iLCJleHAiOjE2OTg3NjU3MjksImlhdCI6MTY5ODE2MDkyOSwia2V5IjoiUDZLMEpORFRISWF3NFJ6K2F4YWJpaEVKWkJFQ214dCtnVEhwR1dDblJjdVNcL2x1RlRrZVJ2anp2eWpUXC9CWmRDd2c3eEI0ZnM5MlFJZXdFdExob3FjaHNuTzNJRVVuZFFiR3IwQzlSb1wvS3dpZ0pRc29IeUNHT3JcL3NOeWlQNjI1UnA5K1V0eXV1R09QTXNpdWVrbzFkRk1ZV1hcL05pOGdYRU1oVzJqeXlCMGs2c0ZVSVlxdk5RZnFTWTBuOTU4WFJyMkU5aFhqaTYxRXlNMFZ1eEZyU2lNSnd0VXRyMXVtMnRNcG9ZUVM5ckhURnZ0eEJFWXV0bWFsNVRGTU55NWRiUEpuY25JeWdRcmZjOHY5N1l0amx0aXB6MzBWTjhTblNvYXlUQ3dDcDZWS21EYm1QOXcrckFDQk1rRnhCaHBqeVwvMmtoK2VteDRZSE5hc25QXC9JZ1pcL3c9PSIsImNvbnRlbnQiOiJsbXgrSUJlMmVFZ0pvd0dRYVlNY2t3VmJrNGJSXC8zbDlkM2lpdlZubjl1TjNyell5RXVhZjY0b1QzNDk3UG1aZXNONDc1QjJ5bVd0bzdGbUpXTEJkQmhoOGpcL1hCSFVcLzFrVU1ldGt1c1wvT2lnVXVQT1gwb1JVMjhOZ1lHaUFVamZkdmp4blpnaHBOblR0WXZ3aVExNzAweldMY1BGdFRSeXNMaE5mWnZxQjcxcTZWMUZBQStcL29iUTZrazBqK3JMRCJ9._W13Xkjvta2ntBBsKR6u08FmrUp1vodhoCIqLQuhaMw",
      loggedIn: "f645bd96-9580-41ce-9a71-4f97dcf46bab",
    },
    language: {
      default: "language",
      signIn: "signInLang",
      externalSignIn: "lang"
    }
  },
  deeplink: {
    key: "ute.rci.deep.link.url",
    url: "/ignite-your-tv/",
  },
  analyticsConstant: {
    applicationName:
      'Connected Home AppBased Auth | https://github.com/RogersCommunications/connectedhome-appbased-auth',
    page: {
      name: 'activate your device',
      hierarchy: ['signin', 'ignite iptv app', 'iginite-your-tv'],
      language: 'en',
      province: 'ON',
    },
    site: { name: 'R' },
    category: 'login',
    user: 'user'
  },
};
